import axios from '@utils/axios-client';
import { IUserModel, IUserUpdate } from 'AppTypes';

class UserAPI {
    prefix = '/api/v1/User'

    async fetchList() {
        const url = `${this.prefix}/GetAll`;
        const response = await axios.get<{ data: IUserModel[] }>(url);
        return response.data;
    }

     

    async insert(params: IUserUpdate) {
        const url = `${this.prefix}/Register`
        return await axios.post(url, params);
    }

    async update(params: IUserUpdate) {
        const url = `${this.prefix}/Update`
        return await axios.put(url, params);
    }

    delete(id: string) {
        const url = `${this.prefix}/Delete?id=${id}`
        return axios.delete(url);
    }

    async getfirsttime(): Promise<boolean> {
        const url = `${this.prefix}/GetFirstTime`;
        const response = await axios.get<boolean>(url);
        return response.data;
    }

    async createfirsttime(id: string, userName: string, jwtToken?: string): Promise<boolean> {
        const headers = jwtToken
            ? { Authorization: `Bearer ${jwtToken}` }
            : undefined;

        const url = `${this.prefix}/CreateFirstTime`;
        const response = await axios.put<boolean>(url, { id, userName }, { headers });
        return response.data;
    }
}

export const userAPI = new UserAPI();